import { v4 as uuidv4 } from 'uuid'

export function guid() {
  return uuidv4()
}

export function setCustomDataValuesToEmptyString(customData) {
  const formatedCustomData = {}
  Object.keys(customData).forEach((key) => {
    formatedCustomData[key] = customData[key] || ''
  })
  return formatedCustomData
}
